import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create number format
export function* createNumberFormatRequest() {
    yield takeEvery(actions.NUMBER_FORMAT_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/number_formats', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.NUMBER_FORMAT_CREATE_SUCCESS,
                number_format: data.number_format,
            });
        }
        catch (error) {
            yield put({
                type: actions.NUMBER_FORMAT_CREATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createNumberFormatSuccess() {
    yield takeEvery(actions.NUMBER_FORMAT_CREATE_SUCCESS, function* () {
        yield message.success(t`The number format is created.`);
    });
}
export function* createNumberFormatFail() {
    yield takeEvery(actions.NUMBER_FORMAT_CREATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read number format list
export function* readNumberFormatListRequest() {
    yield takeEvery(actions.NUMBER_FORMAT_READ_LIST_REQUEST, function* ({ request}, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/number_formats', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.NUMBER_FORMAT_READ_LIST_SUCCESS,
                number_formats: data.number_formats,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.NUMBER_FORMAT_READ_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readNumberFormatListSuccess() {
    yield takeEvery(actions.NUMBER_FORMAT_READ_LIST_SUCCESS, () => {});
}
export function* readNumberFormatListFail() {
    yield takeEvery(actions.NUMBER_FORMAT_READ_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read number format
export function* readNumberFormatRequest() {
    yield takeEvery(actions.NUMBER_FORMAT_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/number_formats/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.NUMBER_FORMAT_READ_SUCCESS,
                number_format: data.number_format,
            });
        }
        catch (error) {
            yield put({
                type: actions.NUMBER_FORMAT_READ_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readNumberFormatSuccess() {
    yield takeEvery(actions.NUMBER_FORMAT_READ_SUCCESS, () => {});
}
export function* readNumberFormatFail() {
    yield takeEvery(actions.NUMBER_FORMAT_READ_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update number format
export function* updateNumberFormatRequest() {
    yield takeEvery(actions.NUMBER_FORMAT_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/number_formats/${id}`, request, context);

            // OK
            yield put({
                type: actions.NUMBER_FORMAT_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.NUMBER_FORMAT_UPDATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateNumberFormatSuccess() {
    yield takeEvery(actions.NUMBER_FORMAT_UPDATE_SUCCESS, function* () {
        yield message.success(t`The number format is updated.`);
    });
}
export function* updateNumberFormatFail() {
    yield takeEvery(actions.NUMBER_FORMAT_UPDATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete number format
export function* deleteNumberFormatRequest() {
    yield takeEvery(actions.NUMBER_FORMAT_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/number_formats/${id}`, null, context);

            // OK
            yield put({
                type: actions.NUMBER_FORMAT_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.NUMBER_FORMAT_DELETE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteNumberFormatSuccess() {
    yield takeEvery(actions.NUMBER_FORMAT_DELETE_SUCCESS, function* () {
        yield message.success(t`The number format is deleted.`);
    });
}
export function* deleteNumberFormatFail() {
    yield takeEvery(actions.NUMBER_FORMAT_DELETE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createNumberFormatRequest),
        fork(createNumberFormatSuccess),
        fork(createNumberFormatFail),
        fork(readNumberFormatListRequest),
        fork(readNumberFormatListSuccess),
        fork(readNumberFormatListFail),
        fork(readNumberFormatRequest),
        fork(readNumberFormatSuccess),
        fork(readNumberFormatFail),
        fork(updateNumberFormatRequest),
        fork(updateNumberFormatSuccess),
        fork(updateNumberFormatFail),
        fork(deleteNumberFormatRequest),
        fork(deleteNumberFormatSuccess),
        fork(deleteNumberFormatFail),
    ]);
}
